import { ContactButton } from "@/components/blocks/ContactButton";
import { LezoTrace, NightDecor } from "@/components/blocks/decor/Decor";
import { Reveal } from "@/components/motion/motion";
import type { ContactNeed } from "@/lib/contact";
import { Section } from "./Section";
import { displayH2 } from "./SectionHeading";

/** Final call at the end of every page: a question and one action. */
export function Cta({
	id,
	title,
	description,
	button,
	need,
	placement,
}: {
	id: string;
	title: string;
	description: string;
	button: string;
	need?: ContactNeed;
	placement: string;
}) {
	return (
		<Section
			id={id}
			tone="night"
			decor={<NightDecor glow="center" />}
			containerClassName="py-24 md:py-36"
		>
			<div className="grid items-end gap-10 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:gap-20">
				<Reveal className="space-y-6">
					<h2
						className={`${displayH2} max-w-3xl md:text-[clamp(2.2rem,4.2vw,3.6rem)]`}
					>
						{title}
					</h2>
					<p className="max-w-xl text-lg text-pretty text-muted-foreground">
						{description}
					</p>
				</Reveal>
				<div className="flex items-end">
					<LezoTrace className="mb-7 hidden h-48 w-28 shrink-0 lg:block" />
					<Reveal delay={0.4}>
						<ContactButton need={need} placement={placement} size="xl">
							{button}
						</ContactButton>
					</Reveal>
				</div>
			</div>
		</Section>
	);
}
